// Shared chevron used at the end of every CTA button site-wide.
// Sits inside a parent with className="group" so the arrow nudges right on hover.
const BtnArrow = ({ className = "" }: { className?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
    className={`transition-transform duration-300 ease-out group-hover:translate-x-1 ${className}`}
  >
    <path
      d="M5 3L9 7L5 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BtnArrow;
